export class ItemConsultasCliente {
    mes;
    entidad_financiera;
    constructor() {
        this.mes = "";
        this.entidad_financiera = "";
    }
}
